import React from 'react'
import { Container } from 'react-bootstrap'
import DashboardContainer from 'shared/components/DashboardContainer-component/DashboardContainer'

const Status = () => {
  return (
    <Container>
      <h1>Work In Progress</h1>
    </Container>
  )
}

export default Status